<template>
	<div class="">
		<v-col cols="12" sm="12" class="">
			<v-data-table
				v-if="hasItens"
				:headers="colunas"
				:items="itens"
				:server-items-length="totalItens"
				item-key="id"
				:options="paginacaoInterna"
				no-data-text="Não há documentos cadastrados"
				hide-default-footer
				class="arp-listview row-pointer"
			>
				<template #item.acoes="{ item }">
					<listagem-modal-documentos-botoes-acoes :documento="item"></listagem-modal-documentos-botoes-acoes>
				</template>
				<template #item.dataCadastro="{ item }">
					<span>{{ item.dataCadastro | formatDataHourMinuteFilter }}</span>
				</template>
			</v-data-table>

			<template-listagem-vazia :total-itens="totalItens" :textos="textos"></template-listagem-vazia>

			<paginacao-tabela
				v-if="totalItens > 0"
				:page.sync="paginacaoInterna.page"
				:rows-per-page.sync="paginacaoInterna.rowsPerPage"
				:totalPaginas="totalPaginas"
				:totalItens="totalItens"
				@resetar-page="resetarPage"
			></paginacao-tabela>
		</v-col>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import ListagemModalDocumentosBotoesAcoes from '@/views/pages/ata/pesquisa/listagem/modal-documentos/botoes-acoes/ListagemModalDocumentosBotoesAcoes.vue'

export default {
	name: 'listagem-modal-documentos',
	components: {ListagemModalDocumentosBotoesAcoes },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Título', 'titulo', '60%'),
				new TabelaColunaUtils('Data inclusão', 'dataCadastro', '25%'),
				new TabelaColunaUtils('Ações', 'acoes', '15%'),
			],
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontrados documentos',
			},
		}
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
	},
}
</script>
<style scoped lang="stylus"></style>
